module.exports = __webpack_public_path__ + "8ff79860159a229285445b4d88469a38.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=1400!./images/Foto_Manja_Herrmann-0187_klein.jpg
// module id = 740
// module chunks = 0